var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.chip
    ? _c(
        "span",
        {
          staticClass: "address-verify-chip",
          class: ["text-" + _vm.chip.color, { clickable: _vm.clickable }],
          attrs: { title: _vm.chip.title },
          on: { click: _vm.onClick }
        },
        [
          _c("q-icon", {
            class: { spin: _vm.chip.spin },
            attrs: { name: _vm.chip.icon }
          }),
          _c("span", [_vm._v(_vm._s(_vm.chip.label))]),
          _vm.hasPopover && !_vm.disable
            ? _c(
                "q-popover",
                {
                  ref: "popover",
                  attrs: {
                    anchor: "bottom left",
                    self: "top left",
                    offset: [0, 4]
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "address-verify-popover" },
                    [
                      _vm.status === "fix"
                        ? [
                            _c("div", { staticClass: "caption" }, [
                              _vm._v("You entered")
                            ]),
                            _c("div", { staticClass: "address entered" }, [
                              _vm._v(_vm._s(_vm.enteredText))
                            ]),
                            _c("div", { staticClass: "caption" }, [
                              _vm._v("Google suggests")
                            ]),
                            _c("div", { staticClass: "address suggested" }, [
                              _vm._v(_vm._s(_vm.suggestedText))
                            ]),
                            _c(
                              "div",
                              { staticClass: "actions" },
                              [
                                _c("q-btn", {
                                  attrs: {
                                    flat: "",
                                    dense: "",
                                    size: "sm",
                                    color: "grey-8",
                                    label: "Cancel"
                                  },
                                  on: { click: _vm.closePopover }
                                }),
                                _c("q-btn", {
                                  staticClass: "q-px-sm",
                                  attrs: {
                                    dense: "",
                                    size: "sm",
                                    color: "positive",
                                    label: "Accept"
                                  },
                                  on: { click: _vm.accept }
                                })
                              ],
                              1
                            )
                          ]
                        : [
                            _c("div", { staticClass: "message" }, [
                              _vm._v(
                                "\n          Google could not confirm this address. The class can still be saved; if the address is wrong, check the street, unit, city, state and ZIP, then try again.\n        "
                              )
                            ]),
                            _c("div", { staticClass: "address entered" }, [
                              _vm._v(_vm._s(_vm.enteredText))
                            ]),
                            _c(
                              "div",
                              { staticClass: "actions" },
                              [
                                _c("q-btn", {
                                  attrs: {
                                    flat: "",
                                    dense: "",
                                    size: "sm",
                                    color: "grey-8",
                                    label: "Close"
                                  },
                                  on: { click: _vm.closePopover }
                                }),
                                _c("q-btn", {
                                  staticClass: "q-px-sm",
                                  attrs: {
                                    dense: "",
                                    size: "sm",
                                    color: "primary",
                                    label: "Check again"
                                  },
                                  on: { click: _vm.checkAgain }
                                })
                              ],
                              1
                            )
                          ]
                    ],
                    2
                  )
                ]
              )
            : _vm._e()
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }